import { useMemo } from "react";
import getStripe from "./load-stripe";
import buildElementsOptions from "./build-elements-options";
import useCustomerSession from "./use-customer-session";

const useStripeElements = ({
  publishableKey,
  enabled = true,
  amount = null,
  customerSessionPath = null,
  paymentMethodsConfigId = null,
  buildOptions = buildElementsOptions
}) => {
  const active = Boolean(enabled && publishableKey);

  const stripePromise = useMemo(
    () => (active ? getStripe(publishableKey) : null),
    [active, publishableKey]
  );

  const customerSession = useCustomerSession({
    path: customerSessionPath,
    enabled: active && Boolean(customerSessionPath)
  });

  const ready = active && Boolean(stripePromise) && customerSession.fetched && amount != null;

  const elementsOptions = useMemo(
    () =>
      buildOptions({
        amount,
        customerSessionClientSecret: customerSession.clientSecret,
        paymentMethodsConfigId
      }),
    [buildOptions, amount, customerSession.clientSecret, paymentMethodsConfigId]
  );

  return { stripePromise, elementsOptions, ready };
};

export default useStripeElements;
